import React from 'react';
import PropTypes from 'prop-types';
import { NavigationBar } from './NavigationBar';
import { Header } from './styles';

export const BaseHeader = ({
  topSegment,
  leftSegment,
  centerSegment,
  rightSegment,
  bottomSegment,
  logoImg = null,
  logoUrl,
  logoSrText,
  sticky = false,
  stickyBanner = false,
  bgColor = 'background.dark',
  fontColor = 'text.lightest',
  cro,
  showLogo = true,
  withDropShadow = false,
  centerLogo,
  headerVerticalPadding,
}) => {
  return (
    <Header
      role="banner"
      $cro={cro}
      $centerLogo={centerLogo}
      $hasBanner={!!topSegment}
      $sticky={sticky}
      $stickyBanner={stickyBanner}
      $dropshadow={withDropShadow}
      $bgColor={bgColor}
      $fontColor={fontColor}
    >
      {topSegment}
      <div>
        <NavigationBar
          logoImg={logoImg}
          showLogo={showLogo}
          logoUrl={logoUrl}
          logoSrText={logoSrText}
          leftSegment={leftSegment}
          centerSegment={centerSegment}
          rightSegment={rightSegment}
          bgColor={bgColor}
          fontColor={fontColor}
          verticalPadding={headerVerticalPadding}
        />
      </div>
      {bottomSegment}
    </Header>
  );
};

BaseHeader.displayName = 'BaseHeader';

BaseHeader.propTypes = {
  logoUrl: PropTypes.string,
  logoSrText: PropTypes.string,
  topSegment: PropTypes.node,
  leftSegment: PropTypes.node,
  centerSegment: PropTypes.node,
  rightSegment: PropTypes.node,
  bottomSegment: PropTypes.node,
  sticky: PropTypes.bool,
  stickyBanner: PropTypes.bool,
  showLogo: PropTypes.bool,
  cro: PropTypes.bool,
  centerLogo: PropTypes.bool,
  logoImg: PropTypes.object,
  headerVerticalPadding: PropTypes.number,
};
